import { Box, Button, Typography } from "@mui/material"
import Dropzone from "react-dropzone"
import FileIcon from "./FileIcon"


const FileUploadField = ({
    onDrop, acceptedFiles = [], onRemoveAcceptedFile, disabled,
    nameGetter = x => x.file.name,
    typeGetter = x => x.file.type,
    maxFiles, maxSize = 10
}) => {

    return <Dropzone
        maxSize={1024 * 1024 * maxSize}
        noDragEventsBubbling
        onDrop={onDrop}
        disabled={disabled}
        maxFiles={maxFiles}
    >
        {({ getRootProps, getInputProps }) => {

            const { onClick, ...rootProps } = getRootProps()

            return <Box
                {...rootProps}
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "#E8F2FF",
                    borderRadius: "5px",
                    borderColor: "primary",
                    mt: 2, mb: 2, p: 1,
                    minHeight: 120,
                    width: "100%"
                }}
            >
                <Box
                    sx={{
                        p: 1,
                        display: "flex",
                        flexWrap: "wrap",
                    }}
                >
                    {acceptedFiles.length === 0 ? (
                        <Box sx={{ display: "flex", flexDirection: "column", m: 1 }}>
                            <Typography align="center" >
                                Перетащите файлы сюда или загрузите вручную
                            </Typography>
                            <Typography color="grey" variant="subtitle2" align="center" >
                                Максимальный размер файла - 10мб
                            </Typography>
                        </Box>
                    ) : acceptedFiles.map((acceptedFile, acceptedFileIndex) => <FileIcon
                        key={acceptedFileIndex}
                        name={nameGetter(acceptedFile)}
                        type={typeGetter(acceptedFile)}
                        onDelete={disabled ? undefined : () => onRemoveAcceptedFile(acceptedFileIndex)}
                    />)
                    }
                </Box>

                <Button disabled={disabled} sx={{ height: 35 }} variant="contained" onClick={onClick}>
                    Добавить файлы
                </Button>

                <input {...getInputProps()} />
            </Box>
        }}
    </Dropzone>
}

export default FileUploadField